import { createFileRoute } from '@tanstack/react-router'
import Blog from '@/modules/blog'

export const Route = createFileRoute('/_authenticated/blog/')({
  component: Blog,
})
